import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";
//Function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

export const createAttachment = async (files, filesInfo = null) => {
  const tenant = getTenant();

  let formData;
  if (filesInfo) {
    formData = new FormData();
    files.forEach((file) => {
      formData.append("attachments", file);
    });
    files.forEach((file) => formData.append(file.name, filesInfo[file.name]));
  } else {
    formData = files;
  }

  try {
    const resp = await apiCall.post(`${tenant}/api/attachment/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return resp.data;
  } catch (error) {
    console.error(error);
    showErrorMessage(getErrorMessage(error, "attachments"));
    throw error;
  }
};

export const createAttachmentForReport = async (id, files) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/create/attachment/report/${id}/`,
      files,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return resp.data;
  } catch (error) {
    console.error(error);
    const errorMessage = getErrorMessage(error, "attachments");
    showErrorMessage(errorMessage);
    throw new Error(errorMessage, { cause: error });
  }
};

export const getListAttachmentForReport = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/list/attachment/report/${id}/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "attachments"));
    console.error(error);
  }
};

export const deleteAttachmentForReport = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/delete/attachment/report/${id}/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "attachments"));
    console.error(error);
  }
};

export const uploadInterviewAudio = async (interviewId, alias, audioBlob) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  const formData = new FormData();
  const timestamp = Date.now();
  const fileName = `interview_${interviewId}_${timestamp}.webm`;
  formData.append("audio", audioBlob, fileName);
  formData.append("interview_id", interviewId);
  formData.append("alias", alias);

  try {
    const resp = await apiCall.post(
      `${tenant}/api/interview/audio/upload/`,
      formData,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return resp.data;
  } catch (error) {
    console.error("Error uploading interview audio:", error);
    throw error;
  }
};
